<template>
  <div>
    <b-collapse v-for="(item, index) in info" :key="index" :open="false">
      <SlideoutNavItem slot="trigger" :item="item" />
      <b-collapse
        v-for="(nItem, index) in item.links"
        :key="index"
        :open="false"
        class="slideout-link-item-nested"
      >
        <SlideoutNavItem slot="trigger" :item="nItem" />
        <div
          v-for="(link, index) in nItem.links"
          :key="index"
          class="slideout-link-item nested"
        >
          <a :href="link.url">
            {{ link.label }}
          </a>
        </div>
      </b-collapse>
    </b-collapse>
  </div>
</template>

<script>
import SlideoutNavItem from "@/components/SlideoutNavItem";

export default {
  name: "SlideoutNav",
  data() {
    return {};
  },
  components: {
    SlideoutNavItem
  },
  props: {
    info: Array
  }
};
</script>

<style lang="scss" scoped>
.slideout-link-item {
  &-nested {
    a {
      padding-left: 2em;
      text-transform: none;
    }
    .nested {
      a {
        padding-left: 3em;
      }
    }
  }
}
</style>
